import { Award } from 'lucide-react';

export type PartnerMilestoneRatesRow = {
  hospitalId: string;
  hospitalName: string;
  newReferral: number;
  opdVisit: number;
  ipdAdmission: number;
};

type Props = {
  rates: PartnerMilestoneRatesRow[];
  compact?: boolean;
};

function MilestoneCell({ label, points }: { label: string; points: number }) {
  return (
    <div className="rounded-xl border border-white/10 bg-black/20 px-3 py-2 text-center">
      <p className="text-[10px] font-medium uppercase tracking-wide text-slate-500">{label}</p>
      <p className="mt-0.5 text-lg font-semibold text-white">
        {points}
        <span className="ml-0.5 text-xs font-normal text-slate-400">pts</span>
      </p>
    </div>
  );
}

export default function PartnerMilestoneRatesCard({ rates, compact }: Props) {
  if (!rates.length) return null;

  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <div className="flex items-center gap-2 text-sm font-medium text-slate-300">
        <Award className="h-4 w-4 text-amber-400" />
        Your earning rates
      </div>
      <p className="mt-1 text-xs text-slate-500">
        Points configured for your account per hospital (set by admin). Credits apply when each
        milestone is completed.
      </p>

      <div className={`mt-4 space-y-4 ${compact ? '' : ''}`}>
        {rates.map((row) => (
          <div key={row.hospitalId}>
            {rates.length > 1 && (
              <p className="mb-2 text-sm font-medium text-cyan-200/90">{row.hospitalName}</p>
            )}
            <div className="grid grid-cols-3 gap-2 sm:gap-3">
              <MilestoneCell label="New referral" points={row.newReferral} />
              <MilestoneCell label="OPD visit" points={row.opdVisit} />
              <MilestoneCell label="IPD admission" points={row.ipdAdmission} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
